import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import notifier from '../../../_utils/notifier';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { Page } from '../../hoc/Page.jsx';
import { ThreeDots } from '../common/Placeholders.jsx';

import { deleteUserPhoto, uploadUserPhoto, getUserData, updateUserData } from '../../actions/user';
import { createContact, deleteContact, updateContact, getContacts } from '../../actions/contacts';
import RefferalLink from './RefferalLink.jsx';
import UserAbout from "./UserAbout/UserAbout.jsx";
import Contacts from './Contacts/Contacts.jsx';
import LivingPlace from './LivingPlace/LivingPlace.jsx';
import UserPhotoEditor from '../common/UserPhotoEditor.jsx';
import { setPageHeadObject } from '../../actions/app';


class Home extends React.Component {
  state = {
    isLoading: true,
    livingPlaceFetching: false,
    userAboutFetching: false,
    createContactFetching: false,
    updateContactFetching: false,
    updateContactId: null,
  };

  componentDidMount() {
    this.props.getUserData(this.props.userSlug)
      .then(response => {
        this.setState({ isLoading: false });
        this.props.setPageHeadObject({ title: response.full_name });
      });
    this.props.getContacts();
  }

  handleLivingPlaceSubmit = async (formData) => {
    this.setState({ livingPlaceFetching: true });
    let response = await this.props.updateUserData(formData);
    this.setState({ livingPlaceFetching: false });
    if (response && 'errors' in response){
      notifier.alert(gettext('Указанное место жительства не найдено, проверьте правильность написания названия ' +
                             'населенного пункта. И выберите место жительство из предложенных вариантов.'))

    };
  };

  handleContactFormSubmit = (formData) => {
    this.setState({createContactFetching: true});
    this.props.createContact(this.props.userId, formData)
    .then(() => this.setState({createContactFetching: false}));
  };

  handleDeleteContact = (contactId) => {
    this.props.deleteContact(contactId);
  };

  handleUpdateContact = (contactId, accountValue) => {
    this.setState({updateContactFetching: true, updateContactId: contactId});
    this.props.updateContact(contactId, accountValue)
      .then(() => this.setState({updateContactFetching: false, updateContactId: null}));
  };

  handleAboutFormSubmit = (formData) => {
    this.setState({userAboutFetching: true});
    this.props.updateUserData(formData).then(() => { this.setState({userAboutFetching: false}) });
  };

  render() {
    const {isLoading, livingPlaceFetching, userAboutFetching, photoFetching,
           createContactFetching, updateContactFetching, updateContactId} = this.state;
    if (isLoading) return <div><ThreeDots/></div>;

    return <div>
      <div className="media my-3 d-flex flex-row flex-wrap">
        <UserPhotoEditor photo={ this.props.photo } sex={ this.props.sex }/>
        <div className="media-body flex-column">
          <RefferalLink invite_link={this.props.invite_link}/>
          <div className="mb-3">
            <ul className="list-unstyled">
              <li className="mb-2">
                <span className="font-weight-bold">{gettext('Дата регистрации')}:</span> {this.props.registration_date}
              </li>
              <li className="mb-2">
                <span className="font-weight-bold">{gettext('Просмотров профиля')}:</span> {this.props.views_count}
              </li>
              <li className="mb-2"><LivingPlace livingPlace={this.props.living_place}
                                                isFetching={livingPlaceFetching}
                                                onSubmit={this.handleLivingPlaceSubmit}/></li>
            </ul>
          </div>
          <Contacts contacts={this.props.contacts}
                    updateContactId={updateContactId}
                    isUpdateFetching={updateContactFetching}
                    isCreateFetching={createContactFetching}
                    onSubmit={this.handleContactFormSubmit}
                    onDelete={this.handleDeleteContact}
                    onChange={this.handleUpdateContact}/>
        </div>
      </div>
      <UserAbout userAbout={this.props.about} isFetching={userAboutFetching} onSubmit={this.handleAboutFormSubmit}/>
      {/*  последние покупки или последние предложения */}
    </div>
  }
}

let mapStateToProps = (state) => {
  return {
    userSlug: state.auth.slug,
    lang: state.auth.lang,

    full_name: state.user.full_name,
    photo: state.user.photo,
    sex: state.user.sex,
    about: state.user.about,
    invite_link: state.user.invite_link,
    views_count: state.user.views_count,
    registration_date: state.user.registration_date,
    living_place: state.user.living_place,

    contacts: state.contacts.contacts,
  }
};

export default compose(
  connect(mapStateToProps,
    {
      getUserData, updateUserData,
      getContacts, createContact, deleteContact, updateContact,
      deleteUserPhoto, uploadUserPhoto,

      setPageHeadObject
    }),
  LoginRequired,
  Page
)(Home)

